module.exports = __webpack_public_path__ + "img/1.494222a9.png";